import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { getDriver } from '../../store/ducks/driver/actions';

export default function useGetDriver() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(id: string, callback?: any) {
    try {
      setLoading(true);
      const response = await api.get(`v1/backoffice/drivers/${id}`);

      if (response.status === 200) {
        dispatch(getDriver({ ...response.data }));

        if (callback) {
          callback();
        }
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
